// Module
var code = "<cjs-input ref=\"inputDecimal\" inputType=\"number\" class=\"flex-container-row flex-item-auto\"></cjs-input>";
// Exports
module.exports = code;